import { useTranslation } from "react-i18next";
import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./global.scss";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals())
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
